<template>
  <!-- partial -->
  <div class="page-content">
    <div class="row">
      <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12">
        <h5 class="txt-dark">
          <back-button
            link="/procurement-management/account-codes"
          ></back-button>
          Update Account Code
        </h5>
      </div>
      <!-- Breadcrumb -->
      <div class="col-lg-4 col-sm-6 col-md-4 col-xs-12">
        <ol class="breadcrumb breadcrumb-line" style="float: right">
          <li class="breadcrumb-item">
            <router-link :to="`/`">Dashboard</router-link>
          </li>
          <li class="breadcrumb-item">Procurement Management</li>
          <li class="breadcrumb-item">
            <router-link :to="`/procurement-management/account-codes`"
              >Account Codes</router-link
            >
          </li>
          <li class="breadcrumb-item active" aria-current="page">Update</li>
        </ol>
      </div>
    </div>
    <!-- /Breadcrumb -->
    <!-- Form  -->
    <div class="row">
      <div class="col-md-10 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <div class="row mb-3">
              <label class="col-sm-2 col-form-label">Vessel</label>
              <div class="col-sm-10">
                <my-select
                  disableFormControl="true"
                  :selection.sync="form.vessel_id"
                  :suggestions="vessels"
                  placeholder="Select vessel"
                ></my-select>
              </div>
            </div>
            <div class="row mb-3">
              <label class="col-sm-2 col-form-label">Date</label>
              <div class="col-sm-10">
                <my-datepicker
                  :date.sync="form.date"
                  placeholder="Enter Date"
                ></my-datepicker>
              </div>
            </div>
            <div class="row mb-3">
              <label class="col-sm-2 col-form-label">Remarks</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  v-model="form.remarks"
                  class="form-control"
                  placeholder="Remarks"
                />
              </div>
            </div>

            <div class="row mb-3">
              <label class="col-sm-2 col-form-label"></label>
              <div class="col-sm-8">
                <my-select
                  disableFormControl="true"
                  :selection.sync="form.owner_account_code_id"
                  :suggestions="owner_account_codes"
                  placeholder=""
                ></my-select>
              </div>
              <div class="col-sm-2">
                <button
                  class="btn btn-primary"
                  @click="add_account_code_detail(form.owner_account_code_id)"
                >
                  Add
                </button>
              </div>
            </div>

            <div class="table-responsive">
              <table id="dataTableExample" class="table table-hover">
                <thead>
                  <tr>
                    <th>Sr No</th>
                    <th>Parent Account Code</th>
                    <th>Account Code</th>
                    <th>Account Name</th>
                    <th>Classification</th>
                    <th>Account Head</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Table Loader -->
                  <loading-table
                    :isLoading="isLoading"
                    cols="8
                        "
                  ></loading-table>
                  <!-- If No Data Received-->
                  <tr v-if="form.account_code_details.length == 0">
                    <td colspan="8" class="text-center" style="color: grey">
                      No Data Found
                    </td>
                  </tr>
                  <!-- If data Received -->
                  <tr
                    v-for="(
                      account_code_detail, at
                    ) in form.account_code_details"
                    :key="`account_code_detail${at}`"
                  >
                    <td>{{ at + 1 }}</td>
                    <td>{{ account_code_detail.parent }}</td>
                    <td>{{ account_code_detail.account_code }}</td>
                    <td>{{ account_code_detail.account_name }}</td>
                    <td>
                      {{ account_code_detail.classification }}
                    </td>
                    <td>
                      {{ account_code_detail.account_head }}
                    </td>
                    <td>
                      <div>
                        <button
                          class="btn btn-danger btn-sm"
                          @click="
                            deleteOwnerAccountDetails(account_code_detail)
                          "
                        >
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- /Table -->
            </div>
            <br />
            <div class="form mb-0">
              <submit-button
                :isLoading="isLoading"
                @submit="update"
                text="Update"
                style="float: right"
              ></submit-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- partial -->
</template>

<script type="text/javascript">
import axios from "axios";

export default {
  name: "Account CodeUpdate",
  data() {
    return {
      form: {
        vessel_id: "",
        owner_account_code_id: "",
        account_code_details: [],
      },
      vessels: [],
      owner_account_codes: [],
      isLoading: false,
    };
  },
  mounted() {
    this.getData();
    this.getMasters();
  },
  methods: {
    async getMasters() {
      let masters = await axios.get("account_codes/masters");
      this.masters = masters.data;
      this.masters.vessels.forEach((vessel) => {
        this.vessels.push({
          id: vessel.id,
          name: vessel.name,
        });
      });
      this.masters.owner_account_codes.forEach((owner_account_code) => {
        this.owner_account_codes.push({
          id: owner_account_code.id,
          name:
            owner_account_code.parent.code +
            "  |  " +
            owner_account_code.parent.name,
        });
      });

      // console.log(this.form.owner_account_code_id);
      let owner_account_code = this.masters.owner_account_codes;
      owner_account_code.forEach((account_code_detail) => {
        // console.log(account_code_detail);
        if (account_code_detail.id == this.form.owner_account_code_id) {
          // if (index <= 1) {
          this.form.account_code_details.push({
            id: account_code_detail.id,
            parent: account_code_detail.parent.name,
            account_name: account_code_detail.account_name,
            account_code: account_code_detail.account_code,
            classification: account_code_detail.classification.name,
            account_head: account_code_detail.account_head.name,
            // owner_account_code_id: owner_account_code_id,
          });
          // }

          // this.form.account_code_details = this.form.account_code_details.filter(
          //   (ar) => ar !== account_code_detail
          // );
          // console.log(account_code_detail);
        }
      });
    },
    async getData() {
      this.isLoading = true;
      let form = await axios.get(
        `/account_codes/${this.$route.params.account_code_Id}`
      );
      this.form = form.data.data;
      // console.log(this.form);
      this.isLoading = false;
    },
    async update() {
      try {
        this.isLoading = true;
        this.form.owner_account_code_id;

        await axios.post("/account_codes", this.form);
        this.isLoading = false;
        this.$router.push("/procurement-management/account-codes");
      } catch (e) {
        this.isLoading = false;
      }
      // try {
      //   this.isLoading = true;
      //   await axios.post(
      //     `/account_codes`,
      //     this.form
      //   );
      //   this.isLoading = false;
      //   this.$router.push("/procurement-management/account-codes");
      // } catch (e) {
      //   this.isLoading = false;
      // }
    },
    async add_account_code_detail(owner_account_code_id) {
      let owner_account_code = this.masters.owner_account_codes;
      owner_account_code.forEach((account_code_detail) => {
        if (account_code_detail.id == owner_account_code_id) {
          this.form.account_code_details.push({
            id: account_code_detail.id,
            parent: account_code_detail.parent.name,
            account_name: account_code_detail.account_name,
            account_code: account_code_detail.account_code,
            classification: account_code_detail.classification.name,
            account_head: account_code_detail.account_head.name,
          });
          // console.log(this.form.account_code_details);
        }
      });
    },
    deleteOwnerAccountDetails(account_code_detail) {
      this.form.account_code_details = this.form.account_code_details.filter(
        (ar) => ar != account_code_detail
      );
    },
  },
};
</script>
